module.exports = __webpack_public_path__ + "static/media/Library_4.219ca30c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/library/Library_4.png
// module id = 1291
// module chunks = 3